//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import {
  minLength,
  required,
  email
} from "vuelidate/lib/validators";
import {validateEmail} from "~/helpers/validate";
import {parseUtmLabels} from "~/helpers/formSend";

export default BaseCmsBlock.extend({
  name: "PartnerFormBlock",

  data: function () {
    return {
      form: {
        email: "",
        contact: "",
        countPort: "",
        countrySimCard: "",
        yourEquipment: "",
        message: "",
      },
      acceptForm: true
    }
  },

  computed: {
    errorEmail: function () {
      const error = this.$v?.form?.email;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }
      if (!error.email) {
        return this.$t('errorsValidationForms.requiredForFill')
      }
      if (!error.required) {
        return this.$t('errorsValidationForms.requiredForFill')
      }

      return null
    },
    errorСontact: function () {
      const error = this.$v?.form?.contact;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return this.$t('errorsValidationForms.requiredForFill')
      }

      return null
    },
    errorCountPort: function () {
      const error = this.$v?.form?.countPort;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return this.$t('errorsValidationForms.requiredForFill')
      }

      return null
    },
    errorCountrySimCard: function () {
      const error = this.$v?.form?.countrySimCard;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return this.$t('errorsValidationForms.requiredForFill')
      }

      return null
    },
    errorYourEquipment: function () {
      const error = this.$v?.form?.yourEquipment;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return this.$t('errorsValidationForms.requiredForFill')
      }

      return null
    },
    errorMessage: function () {
      const error = this.$v?.form?.message;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return this.$t('errorsValidationForms.requiredForFill')
      }

      return null
    },

    isRecaptcha: function () {
      return Boolean(Number.parseFloat(this.$store?.state?.appState?.config?.useReCaptchaForForms || 0))
    }
  },

  validations: function () {
    const form = {
      email: {
        email,
        required
      },
      contact: {
        required
      },
      countPort: {
        required
      },
      countrySimCard: {
        required
      },
      yourEquipment: {
        required
      },
      message: {
        // required
      },
    };

    return {
      form,
    };
  },

  methods: {
    resetForm: function () {
      this.form = {
        contact: "",
        countPort: "",
        countrySimCard: "",
        yourEquipment: "",
        message: "",
      };
      this.$v.$reset();
    },
    submitForm: async function () {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      }

      this.$store.commit("loading/setLoading", {name: 'popUpLoading', value: true});
      const message = [
        `Email: ${this.form.email}`,
        `Контакт: ${this.form.contact}`,
        `Количество портов оборудования: ${this.form.countPort}`,
        `Страны «происхождения» сим-карт: ${this.form.countrySimCard}`,
        `Ваше оборудование: ${this.form.yourEquipment}`,
        `Что ещё нам важно знать о вас: ${this.form.message}`,
      ].join(";<br/>");
      const email = Boolean(validateEmail(this.form.email)) ? this.form.email : 'info@info.info';
      const utmLabels = parseUtmLabels();
      const body = {
        type: "Стать партнером",
        nophone: 1,
        message: message,
        email: email,
        url: window.location.href,
        additional_data: {
          ...utmLabels
        }
      };
      if (this.isRecaptcha) {
        body['g-recaptcha-response'] = await this.$recaptcha.getResponse().then((res) => {
          return res
        }).catch(() => {
          return ""
        });
        await this.$recaptcha.reset();
      }
      const response = await this.$api.agent.transport.post('/form/send', body).then((res) => res.data).catch((err) => ({ error: err.response }));
      if (response?.error) {
        let errorMessage = [];
        if (Array.isArray(response?.error?.data) && response?.error?.data.length) {
          errorMessage = response?.error?.data.map((t) => t.message)
        }
        if (!errorMessage.length) {
          errorMessage.push(this.$t('partnerPage.popUp.errorForm'))
        }
        this.$store.commit("loading/setLoading", {name: 'popUpLoading', value: false});
        this.$toast.error(errorMessage.join(";<br/>"));
        return
      }
      this.$store.commit("loading/setLoading", {name: 'popUpLoading', value: false});
      this.$toast.success(this.$t('partnerPage.popUp.successForm'))
      this.resetForm();
    }
  }
})
